import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({
    st0: {
        fill: '#00D7FF',
    },

    st1: {
        fill: '#FFFFFF',
    },

    st10: {
        fill: 'none',
    },

    st11: {
    },

    st12: {
        fontSize: '16px',
        fontWeight: '500',
    },

}));
